import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {SendTextDialogController} from '../SendTextDialog.controller';

@observer
export class SendTextDialogHeader extends TechseeBaseComponent<{ctrl: SendTextDialogController}> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;
        return (
            <div className='sub-modal-header'>
                <h3 className='modal-title'>{ctrl.translate(ctrl.titleKey)}</h3>
            </div>
        );
    }
}
